import React, { PropTypes } from 'react';
import SharedTools from '../../lib/SharedTools';
import DataService from '../../lib/DataService';
import { ObservationComponent } from "./commonComponent/ObservationComponent";
import { ObservationDetail } from "./commonComponent/ObservationDetail";
import { message, Spin } from "antd";
import { hashHistory } from 'react-router';

export default class StudentObservationsListPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      semester: props.location.query.semester ? props.location.query.semester : SharedTools.getCurrentSemester(),
      studentId: props.params.studentId ? props.params.studentId : 0,
      classId: props.params.classId ? props.params.classId : 0,
      records: [],
      loading: false,
      isBottom: false
    };
    // bind this
  }

  componentDidMount() {
    this.getDevelopmentRecords()
  }

  toolData(data) {
    let arr = data.filter((post) => post.id).sort(function (x, y) {
      if (x.id > y.id) {
        return -1;
      } else {
        return 1;
      }
    })
    return arr;
  }

  // 观察记录
  getDevelopmentRecords() {
    this.setState({
      loading: true
    })
    let data = {
      semester: this.state.semester,
      student_id: this.state.studentId
    }
    this.state.to_id ? data.to_id = this.state.to_id : undefined;

    DataService.getDevelopmentRecords(data).then((res) => {
      let records = this.state.records.concat(this.toolData(res))
      let to_id = records.length > 0 ? records[records.length - 1].id : undefined;
      this.setState({
        records,
        loading: false,
        to_id,
        isBottom: res.length < 10 ? true : false
      })
    }).catch((error) => {
      console.log(error)
      message.error('请求出错！')
      this.setState({
        loading: false
      })
    });
  }

  goObservationStudentsListPage(e, record) {
    hashHistory.push(`development/evaluation-record/classes/${this.state.classId}/students/${this.state.studentId}/observations/${record.id}?finalEvaluation=${record.complete}&semester=${this.state.semester}`);
    e.stopPropagation();
  }

  goObservationDetail(record) {
    DataService.getObservationDetail(record.id).then((res) => {
      this.setState({
        observation: res,
      })
    }).catch((error) => {
      console.log(error);
    });
  }

  render() {
    let { records, isBottom, observation, loading, studentId } = this.state;
    return (
      <div className="observatio-index-page">
        {records.map(item => <ObservationComponent
          record={item}
          key={item.id}
          goObservationStudentsListPage={this.goObservationStudentsListPage.bind(this)}
          goObservationDetail={this.goObservationDetail.bind(this)}
          showCount={studentId ? false : true}
        />)}

        {!isBottom ?
          <div onClick={() => this.getDevelopmentRecords()} className="more-btn">
            {!loading ? '点击加载更多' : <Spin />}
          </div> : ''}
        <ObservationDetail
          segments={observation ? observation.segments_info : []}
          visible={observation ? true : false}
          handleCancel={() => { this.setState({ observation: null }) }}
        />
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/development/StudentObservationsListPage.jsx